<template>
  <section>
    <ChannelGrowSection class="max-witdh">
      <ChannelSectionTitle>
        <i18n
          :path="
            showHour === '10_HOURS'
              ? 'REGISTRATION_CONFIRMED_1_10H'
              : 'REGISTRATION_CONFIRMED_1_12H'
          "
        >
        </i18n>
      </ChannelSectionTitle>
      <ChanelCaption class="c-my-4">
        <i18n path="REGISTRATION_CONFIRMED_CONTACT">
          <template #email>
            <a :href="`mailto:${$t('APPOINTMENT_BOOKING_EMAIL')}`">{{
              $t('APPOINTMENT_BOOKING_EMAIL')
            }}</a>
          </template>
          <template #br>
            <br />
          </template>
        </i18n>
      </ChanelCaption>
      <ChanelCaption small>
        {{ $t('REGISTRATION_CONFIRMED_2') }}
      </ChanelCaption>
    </ChannelGrowSection>
    <contact-block></contact-block>
  </section>
</template>

<script>
import ContactBlock from '@/components/ContactBlock.vue'
import ChannelSectionTitle from '@/components/ChannelSectionTitle.vue'
import ChannelGrowSection from '@/components/ChannelGrowSection.vue'
import ChanelCaption from '@/components/ChanelCaption.vue'

export default {
  name: 'Confirmation',
  components: {
    ChanelCaption,
    ChannelGrowSection,
    ChannelSectionTitle,
    ContactBlock
  },
  computed: {
    showHour() {
      return this.$store.getters.guestShowHour
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/colors.scss';
@import '@/assets/style/vars.scss';

section {
  text-align: center;
  a {
    color: inherit;
    text-decoration: underline;
  }
}

.max-witdh {
  max-width: $maxWidthXl;
  margin: 0 auto;
}
</style>
